import { combineReducers } from 'redux';
import news from './news/reducers';
import video from './video/reducers';

export default {
    ['leadagilex']: combineReducers({
        video, news
    })
}